import { useEffect } from 'react';
import { useAuth } from '@services/auth';
import { projects } from '@data/projects';
import { checkDeadlines } from '@data/notifications';

/**
 * Component that periodically checks for upcoming project deadlines
 * and creates notifications for relevant users.
 * 
 * This component runs in the background and checks deadlines every 5 minutes.
 */
export default function DeadlineChecker() {
	const { user } = useAuth();

	useEffect(() => {
		if (!user) return;

		// Check deadlines immediately on mount
		const projectsArray = Array.isArray(projects) ? projects : [];
		checkDeadlines(projectsArray).catch(err => {
			console.error('Failed to check deadlines:', err);
		});

		// Then check every 5 minutes
		const interval = setInterval(() => {
			const projectsArray = Array.isArray(projects) ? projects : [];
			checkDeadlines(projectsArray).catch(err => {
				console.error('Failed to check deadlines:', err);
			});
		}, 5 * 60 * 1000); // 5 minutes

		return () => {
			clearInterval(interval);
		};
	}, [user]);

	// This component doesn't render anything
	return null;
}

